<script lang="ts" setup>
import { ref } from '#imports';

type Props = {
    initialVisibility?: boolean;
    title: string;
};

const { initialVisibility, title } = defineProps<Props>();

const visibility = ref<boolean>(initialVisibility);

const { isDesktop } = useDevice();

const handleClick = () => {
    visibility.value = !visibility.value;
};

</script>

<template>
  <CollapsePanel v-model:is-open="visibility"
                 dropdown-class="drop"
                 :label="title"
                 @click="!isDesktop ? handleClick() : {}"
  >
    <template #toggle>
      <div class="display-flex flex-row align-items-center justify-between drop__title">
        <h4 class="compact-600-accent">
          {{ title }}
        </h4>
        <div class="display-flex align-items-center justify-center drop-btn"
             type="button"
             role="button"
             :aria-label="`${title} dropdown panel`"
             :class="{ 'drop-btn--open': visibility }"
             @click="isDesktop ? handleClick() : {}"
        >
          <IconMain class="drop-btn__icon"
                    :size="18"
                    icon="chevron-r-l-d"
          />
        </div>
      </div>
    </template>
    <template #content>
      <div class="drop__content">
        <slot></slot>
      </div>
    </template>
  </CollapsePanel>
</template>

<style lang="scss" scoped>
.drop {
    border-radius: var(--radius-300, 4px);
    background: var(--layer-floor-1);

    &-btn {
      width: 28px;
      height: 28px;
      transition: filter 0.3s ease;
      border: none;
      border-radius: var(--control-300-radius, 2px);
      background: var(--bg-secondary);
      cursor: pointer;

      &:hover, &:active {
        filter: brightness(0.9);
      }

      &--open {
        svg {
          transform: rotate(90deg);
        }
      }

      &__icon {
        transform: rotate(270deg);
      }
    }

    &__title {
      padding: 24px;
    }

  &__content {
    padding: 0 24px 24px;
  }
}
</style>
